<breadcrumb [breadcrumbList]="breadcrumbList"></breadcrumb>
<div *ngIf="pageLoading" class="loader text-center">
	<img src="../assets/img/loading.gif" />
</div>
<div class="card" *ngIf="UserModuleAccess=='Full'">
	<div class="card-header bg-theme">
		{{pagetitle}}
	</div>
	<div class="card-body">
		<form class="form-horizontal" [formGroup]="moduleForm" (ngSubmit)="saveData()" #modform="ngForm">
			<div class="row mb-2">
				<div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
					<ng-select appendTo="body" [items]="companyList" bindLabel="comp_name" bindValue="apptid"
						[clearable]="true" [multiple]="false" id="company" formControlName="company"
						placeholder="Company*" [appearance]="'outline'">
					</ng-select>
					<p *ngIf="showError('company')" class="text-danger">
						<span *ngIf="f.company.errors?.required">
							Required
						</span>
					</p>
				</div>
				<div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
					<div class="form-floating">
						<input class="form-control" [ngClass]="{'is-invalid':showError('name')}" id="name"
							formControlName="name" placeholder="Name*">
						<label for="name">Name*</label>
					</div>
					<p *ngIf="showError('name')" class="text-danger">
						<span *ngIf="f.name.errors?.required">
							Required
						</span>
						<span *ngIf="f.name.errors?.incorrect">
							{{customError.name}}
						</span>
					</p>
				</div>
				<div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
					<div class="form-floating">
						<input class="form-control" [ngClass]="{'is-invalid':showError('email')}" id="email"
							formControlName="email" placeholder="Email*">
						<label for="email">Email*</label>
					</div>
					<p *ngIf="showError('email')" class="text-danger">
						<span *ngIf="f.email.errors?.required">
							Required
						</span>
						<span *ngIf="f.email.errors?.pattern">
							Invalid
						</span>
						<span *ngIf="f.email.errors?.incorrect">
							{{customError.email}}
						</span>
					</p>
				</div>
				<div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
					<div class="form-floating">
						<input class="form-control" [ngClass]="{'is-invalid':showError('phone_no')}" id="phone_no"
							formControlName="phone_no" placeholder="Phone No.*">
						<label for="phone_no">Phone No.*</label>
					</div>
					<p *ngIf="showError('phone_no')" class="text-danger">
						<span *ngIf="f.phone_no.errors?.required">
							Required
						</span>
						<span *ngIf="f.phone_no.errors?.pattern">
							Invalid
						</span>
						<span *ngIf="f.phone_no.errors?.incorrect">
							{{customError.phone_no}}
						</span>
					</p>
				</div>
			</div>
			<div class="row mb-2">
				<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
					<div class="form-floating">
						<input class="form-control" [ngClass]="{'is-invalid':showError('address')}" id="address"
							formControlName="address" placeholder="Address*">
						<label for="address">Address*</label>
					</div>
					<p *ngIf="showError('address')" class="text-danger">
						<span *ngIf="f.address.errors?.required">
							Required
						</span>
						<span *ngIf="f.address.errors?.incorrect">
							{{customError.address}}
						</span>
					</p>
				</div>
			</div>
			<div class="row mb-2">
				<div class="col text-center">
					<button type="submit" [disabled]="showLoader || !modform.dirty"
						class="btn btn-sm btn-outline-success">
						<span class="me-1">
							<fa-icon *ngIf="showLoader" [icon]="['fas', 'spinner']" animation="spin"></fa-icon>
							<fa-icon *ngIf="!showLoader" [icon]="['fas', 'save']"></fa-icon>
						</span>
						<span>Save</span>
					</button>
					<a class="btn btn-sm btn-outline-dark ms-1" [routerLink]="['/app/branch-list']">Cancel</a>
				</div>
			</div>
		</form>
	</div>
</div>
<div *ngIf="UserModuleAccess!='Full'">
	<h3 class="text-center">You don't have access to this section.</h3>
</div>